import React, { useState } from "react";
import "./Bond.css";

export default function BondForm() {
  const [accountNo, setAccountNo] = useState("");
  const [formType, setFormType] = useState("A4");
  const [lineSpacing, setLineSpacing] = useState("0");
  const [withHeader, setWithHeader] = useState(true);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
  };

  return (
    <div className="bond-container">
      {!submitted ? (
        <form className="bond-form" onSubmit={handleSubmit}>
          <h2>Bond Printing</h2>

          <label>Enter A/C No</label>
          <input
            type="text"
            value={accountNo}
            onChange={(e) => setAccountNo(e.target.value)}
            placeholder="Enter account number"
            required
          />

          <label>Select Form Type</label>
          <select value={formType} onChange={(e) => setFormType(e.target.value)}>
            <option>A4 (Full Page)</option>
            <option>Half Page</option>
            <option>Custom</option>
          </select>

          <label>Select Line Spacing</label>
          <select
            value={lineSpacing}
            onChange={(e) => setLineSpacing(e.target.value)}
          >
            <option value="0">Line 0</option>
            <option value="1">Line 1</option>
            <option value="2">Line 2</option>
          </select>

          <label>
            <input
              type="checkbox"
              checked={withHeader}
              onChange={() => setWithHeader(!withHeader)}
            />
            With Header
          </label>

          <button type="submit" className="Bond-btn-submit">Submit</button>
        </form>
      ) : (
        <div className="Bond-container">
          {withHeader && (
            <header className="Bond-header">
              <h1>Manjari India Finance</h1>
              <p>
                CIN: 4892793148 | Email: info@visionpay.in
                <br />
                Regd Office: Sinema Road, Mahnar, Vaishali, Bihar, 844506
                <br />
                Contact: 4892793148
              </p>
            </header>
          )}

          <h2 className="Bond-title">BOND CERTIFICATE</h2>

          <section>
            <h3>Personal Details</h3>
            <p><b>Name:</b> __________________________</p>
            <p><b>Mobile:</b> __________________________</p>
            <p><b>Aadhar:</b> __________________________</p>
            <p><b>PAN:</b> __________________________</p>
            <p><b>Branch:</b> __________________________</p>
            <p><b>Branch Code:</b> __________________________</p>
          </section>

          <section>
            <h3>Account Details</h3>
            <p><b>Account No:</b> {accountNo}</p>
            <p><b>A/C Opening Date:</b> ____________</p>
            <p><b>Maturity Date:</b> ____________</p>
            <p><b>Total Interest:</b> ____________ /-</p>
            <p><b>Total Deposit Amount:</b> ____________ /-</p>
            <p><b>Maturity Amount:</b> ____________ /-</p>
          </section>

          <section>
            <h3>Nominee Details</h3>
            <p><b>Name:</b> __________________________</p>
            <p><b>DOB:</b> __________________________</p>
            <p><b>Aadhar:</b> __________________________</p>
            <p><b>PAN:</b> __________________________</p>
            <p><b>Relation:</b> __________________________</p>
          </section>

          <div className="Bond-signature-section">
            <div>
              <p>_______________________</p>
              <p>Branch Manager</p>
            </div>
            <div>
              <p>_______________________</p>
              <p>Authorized Signatory</p>
            </div>
          </div>

          <button onClick={() => window.print()} className="Bond-btn-print">
            Print Bond
          </button>
        </div>
      )}
    </div>
  );
}
